import { max } from "date-fns";

export enum ColorPalette {
  CHINESE_BLACK = '#190E1F',
  RAISIN_BLACK = '#332E38',
  WHITE = ' #FFFFFF',
  DARK_GRAY = '#666666',
  LESS_LIGHT_GRAY = '#E9E9E9',
  LIGHT_GRAY = '#F3F3F3',
  TIFFANY_BLUE = '#01ACA4',
  COLUMBIA_BLUE = '#cce1e3',
  CONFIRM_BLUE = '#2B9DC5',
  MIDDLE_BLUE = '#80C1C3',
  GREEN = '#16857B',
  VERDIGRIS = '#19797C',
  WARNING_RED = '#C70160',
  PLATINUM = '#E9EAEA',
  BACKGROUND = '#FBFBFB',
  GRADIENT_ONE = 'linear-gradient(179.4deg, #01ACA4 -21.28%, #1D3557 72.79%, #190E1F 100.33%) ',
  GRADIENT_TWO = 'linear-gradient(179.32deg, #01ACA4 -1.72%, #1D3557 100.55%, #190E1F 101.47%)',
  GRADIENT_CONTAINED_BUTTON = 'linear-gradient(179.4deg, #01ACA4 -21.28%, #1D3557 72.79%, #190E1F 100.33%) border-box',
  GRADIENT_CONTAINED_HOVER = 'linear-gradient(179.4deg, #01ACA4 -21.28%, #01ACA4 72.79%, #01ACA4 100.33%) border-box',
  GRADIENT_OUTLINED_BUTTON = 'linear-gradient(white, white) padding-box, linear-gradient(179.4deg, #01ACA4 -21.28%, #1D3557 72.79%, #190E1F 100.33%) border-box',
  GRADIENT_OUTLINED_HOVER = 'linear-gradient(white, white) padding-box, linear-gradient(179.4deg, #01ACA4 -21.28%, #01ACA4 72.79%, #01ACA4 100.33%) border-box',
  DAY_OFF_BG_COLOR = '#E1F0F1',
  WARNING_RED_BG_COLOR = '#ffdee4',
}

export enum BorderRadius {
  SMALL = '5px',
  MEDIUM = '10px',
  HUGE = '50px',
}

export enum TypographyFamily {
  NEXA = 'Nexa',
  ARIAL = 'Arial',
  SANS_SERIF = 'sans-seif',
}

export const toolboxStyles = {
  appRow: {
    justifyContent: 'start',
  },
  inputsBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    justifyContent: 'flex-start',
    mb: 1,
  },
  input: {
    flex: 1,
    minWidth: '175px',
    maxWidth: '400px',
  },
};
